"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ShieldIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M20.758,6.059a1.8,1.8,0,0,0-.379-1.071,1.316,1.316,0,0,0-.935-.394c-2.1,0-2.23-1.1-2.234-1.306a1.311,1.311,0,0,0-1.307-1.3H8.091a1.316,1.316,0,0,0-1.3,1.281c-.006.221-.136,1.321-2.235,1.321A1.314,1.314,0,0,0,3.244,5.911l-.007.14c-.411,7.3,2.581,13.063,8.213,15.825a1.3,1.3,0,0,0,1.146,0C18.22,19.116,21.2,13.349,20.758,6.059Zm-8.737,14.2L12,20.25v-8.5H5.426a18.591,18.591,0,0,1-.5-5.464c2.44-.131,3.333-1.537,3.52-2.592H12v8.056h6.592A12.642,12.642,0,0,1,12.021,20.261Z" })));
}
exports.default = ShieldIcon;
